import API from '../utils/axiosApiHR';
// import { printFrame } from '../helpers/common';
import FileSaver from 'file-saver';

/**Handover */
export const fetchAssetHandovers = async (params) => {
  try {
    const { data } = await API.get('/assets/handovers', { params });
    return data;
  } catch (error) {
    throw error;
  }
};
export const saveAssetHandover = async (body) => {
    try {
      if(body && body.CODE) {
        const { data } = await API.put(`/assets/handover/${body.CODE}`, body);
        return data;
      } else {
        const { data } = await API.post('/assets/handover', body);
        return data;
      }
    } catch (error) {
      throw error;
    }
};
export const getAssetHandover = async ({Code}) => {
  try {
    const { data } = await API.get(`/assets/handover/${Code}`);
    return data;
  } catch (error) {
    throw error;
  }
};
export const deleteAssetHandover = async ({Code}) => {
  try {
    const { data } = await API.delete(`/assets/handover/${Code}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const confirmAssetHandover = async (body) => {
  try {
    const { data } = await API.post(`/assets/handover/confirm`, body);
    return data;
  } catch (error) {
    throw error;
  }
};

export const printAssetHandover = async ({Code}) => {
  try {
    const response = await API.get(`/assets/handover/print/${Code}`, {
      responseType: 'blob'
    });
    const { data } = response;
    const namefile = response.headers['pcs-filename-suggestion'];
    let blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
    FileSaver.saveAs(blob, namefile);
    return true;
  } catch (error) {
    throw error;
  }
};
